import { Helmet } from "react-helmet-async"
import { Outlet } from "react-router"
import { AutomationItem } from "../../../../Automations"
import { useParams } from "../../../../router-utils"

export default function AutomationDetailsLayout() {
	const { automationId } = useParams("/automations/:automationId")

	return (
		<>
			<Helmet>
				<title>Automation Details</title>
			</Helmet>
			<AutomationItem automationId={automationId}>
				{({ automation }) => (
					<Outlet
						context={{
							automationId: String(automation.id),
							automation,
						}}
					/>
				)}
			</AutomationItem>
		</>
	)
}
